import { useEffect, useState } from 'react';
import { Box } from '@mantine/core';
import { useParams } from 'react-router';
import useFetch from '../../../helpers/useFetch';
import ErrorMessage from '../../ErrorMessage';
import Spinner from '../../Spinner';
import FacebookAdForm from './FacebookAdForm';

const FacebookAdsNewForm = ({ from, onCreate, onBack }) => {
  const fetch = useFetch();

  const [facebookAd, setFacebookAd] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const [loading, setLoading] = useState(false);
  const [segments, setSegments] = useState();
  const { accountId, domainId } = useParams();
  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segments?scope=internal`)
      .then(({ segments }) => {
        setSegments(segments);
      })
      .catch((error) => {
        setLoadError(error);
        setSegments([]);
      });
  }, [fetch, accountId, domainId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (from) {
          const { facebookAd } = await fetch(
            `/api/admin/accounts/${accountId}/domains/${domainId}/facebookAds/${from}`
          );
          facebookAd.name = `Copy of ${facebookAd.name}`;
          facebookAd.running = false;
          facebookAd.aborted = false;
          facebookAd.scheduled = false;
          delete facebookAd.id;
          delete facebookAd.facebookCampaignId;
          setFacebookAd(facebookAd);
        } else if (segments !== undefined) {
          setFacebookAd({
            name: 'New facebook campaign',
            dailyBudget: null,
            bidAmount: null,
            durationInDays: 7,
            facebookProductSetId: null,
            placement: {},
            objective: 'OUTCOME_SALES',
            attributionSpec: '7dayClick1dayView',
            callToAction: null,
            showProductName: true,
            showProductPrice: true,
            showProductDescription: true,
            appUrl: null,
            appStore: null,
            appMessage: null,
            promotedVisual: 'carousel',
            imageUrl: null,
            imageHyperLink: null,
            optimizationGoal: null,
          });
        }
      } catch (error) {
        setLoadError(error);
      }
    };

    fetchData();
  }, [from, fetch, segments, accountId, domainId]);

  const create = (facebookAd) => {
    setLoading(true);

    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/facebookAds`, {
      method: 'POST',
      body: JSON.stringify(facebookAd),
    })
      .then(({ facebookAd }) => onCreate(facebookAd))
      .catch(setUserError)
      .finally(() => setLoading(false));
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (facebookAd === undefined) {
    return <Spinner />;
  }

  return (
    <>
      <FacebookAdForm loading={loading} facebookAd={facebookAd} saveFacebookAd={create} onBack={onBack} />

      {userError ? (
        <Box ta="right">
          <ErrorMessage message={userError.message} />
        </Box>
      ) : null}
    </>
  );
};

export default FacebookAdsNewForm;
